<template>
    <div>
      <template v-if="checkTypeStatical==1">
        <div class="courseProgress">
            <h2 class="td-tt">{{$t('new.title19')}}</h2>
            <el-progress 
                class="learnPercent" 
                :text-inside="true" 
                :stroke-width="$CONST.MENU.MAX_WIDTH_STROKE_PROGESS" 
                :percentage="courseProgress "
            ></el-progress>
        </div>
        <!-- Top -->
        <div class="flex-tt" v-if="dataScoreStatic">
          <h2 class="td-tt">{{ $t("manage_lesson.static") }}</h2>
        </div>
        <div v-for="(item, index) in dataScoreStatic" :key="index">
          <div class="nameTestExam">
            <span class="">{{ $t("scoreStatistics.testName") }}: </span>
            <span class="">
              <template v-if="item.examId==null">
                {{ $t("scoreStatistics.finalExam") }}
              </template>
              <template v-else>
                {{ item.examName }}
              </template>
            </span>
          </div>
          <div class="nameTestExam">
            <button v-if="!mobile" class="btn-download-tt" @click="downLoadAll(item)">{{ $t("scoreNew.title9") }}</button>
            <button class="btn-download-tt" @click="getWrongBookUser(item)">{{ $t("new.title193") }}</button>
          </div>
          <!-- --- PC --- -->
          <div class="exam_begins_box">
            <div class="course_box">
              <div class="exam_begins_rule_content">
                <el-table :data="item.listHistoryScoreStatic">
                  <el-table-column
                    type="index"
                    :label="$t('courseList.no')"
                    header-align="center"
                    align="center"
                    width="60"
                  >
                    <template slot-scope="scope">{{
                      scope.$index + 1
                    }}</template>
                  </el-table-column>
                  <el-table-column
                    prop="timeExamStart"
                    :label="$t('scoreStaticNew.timeExamStart')"
                    header-align="center"
                    align="center"
                    min-width="100px"
                    width="180"
                  ></el-table-column>
                  <el-table-column
                    prop="timeExamEnd"
                    :label="$t('scoreStaticNew.timeExamEnd')"
                    header-align="center"
                    align="center"
                    min-width="100px"
                    width="180"
                  ></el-table-column>
                  <el-table-column
                    prop="timeExamConduct"
                    :label="$t('scoreStaticNew.timeExamConductedNew')"
                    header-align="center"
                    align="center"
                    min-width="100px"
                    width="180"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.timeExamConduct }}</span>
                      <span>{{$t('manage_student.minute')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="fullMarks"
                    :label="$t('new.title24')"
                    header-align="center"
                    align="center"
                    min-width="100px"
                    width="140"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.score == null">-</span>
                      <span v-if="scope.row.score != null">{{
                        scope.row.fullMarks
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="res"
                    :label="$t('scoreStatistics.passPercent')"
                    header-align="center"
                    align="center"
                    min-width="100px"
                    width="140"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.score == null">-</span>
                      <span v-if="scope.row.score != null">{{
                        scope.row.checkPassMark
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="score"
                    :label="$t('examResume.point')"
                    header-align="center"
                    align="center"
                    min-width="100px"
                    width="140"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.score == null">-</span>
                      <span>{{ scope.row.score }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="examType"
                    :label="$t('scoreStatistics.judge')"
                    header-align="center"
                    align="center"
                    min-width="90px"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.score == null">-</span>
                      <span
                        v-if="
                          scope.row.score != null &&
                          Number(scope.row.score) >= Number(item.passPercentScore)
                        "
                        >{{ $t("scoreStatistics.point90") }}</span
                      >
                      <span
                        v-if="
                          scope.row.score != null &&
                          Number(scope.row.score) < Number(item.passPercentScore)
                        "
                        >{{ $t("scoreStatistics.point80") }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="score"
                    :label="$t('scoreNew.title10')"
                    header-align="center"
                    align="center"
                    min-width="100px"
                    width="140"
                  >
                    <template slot-scope="scope">
                      <el-button type="text" size="small">
                          <a class="btn_show_details_exam" @click="showDetailsExam(scope.row)" target="_blank">{{$t('courseProgress.look')}}</a>
                        </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="score"
                    :label="$t('new.title79')"
                    header-align="center"
                    align="center"
                    min-width="100px"
                    width="140"
                  >
                    <template slot-scope="scope">
                      <el-button type="text" size="small">
                          <a class="btn_show_details_exam" @click="downLoadFile(scope.row)" target="_blank">{{$t('manage.download')}}</a>
                        </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- --- PC --- -->
          <!-- mobile course_box -->
          <div class="course_box_mobile">
            <div class="box-1" @click="activeRow(index)" v-for="(item1, index1) in item.listHistoryScoreStatic" :key="index1">
              <div class="title_course_box" :class="{'turn-arrow': activeID == index1}">
                <div class="num_order">
                  {{ index1 + 1 }}
                </div>
                <div class="title_course">
                  {{ item1.examDate }}
                </div>
              </div>
              <div class="content_box" :class="{'active-content': activeID == index1}">
                <div class="content_new">
                  <h1>{{ $t("scoreStaticNew.timeExamStart") }}:</h1>
                  <span>{{ item1.timeExamStart }}</span>
                </div>
                <div class="content_new">
                  <h1>{{ $t("scoreStaticNew.timeExamEnd") }}:</h1>
                  <span>{{ item1.timeExamEnd }}</span>
                </div>
                <div class="content_new">
                  <h1>{{ $t("scoreStaticNew.timeExamConductedNew") }}:</h1>
                  <span>{{ item1.timeExamConduct }} {{$t('manage_student.minute')}}</span>
                </div>
                <div class="content_new">
                  <h1>{{ $t("new.title24") }}:</h1>
                  <span v-if="item1.score == null">-</span>
                  <span v-if="item1.score != null">{{ item1.fullMarks }}</span>
                </div>
                <div class="content_new">
                  <h1>{{ $t("scoreStatistics.passPercent") }}:</h1>
                  <span v-if="item1.score == null">-</span>
                  <span v-if="item1.score != null">{{ item1.checkPassMark }}</span>
                </div>
                <div class="content_new">
                  <h1>{{ $t("examResume.point") }}:</h1>
                  <span v-if="item1.score == null">-</span>
                  <span>{{ item1.score }}</span>
                </div>
                <div class="content_new">
                  <h1>{{ $t("scoreStatistics.judge") }}:</h1>
                  <span v-if="item1.score == null">-</span>
                  <span
                    v-if="
                      item1.score != null && Number(item1.score) >= Number(item.passPercentScore)
                    "
                    >{{ $t("scoreStatistics.point90") }}</span
                  >
                  <span
                    v-if="
                      item1.score != null && Number(item1.score) < Number(item.passPercentScore)
                    "
                    >{{ $t("scoreStatistics.point80") }}</span
                  >
                </div>
                <div class="content_new">
                  <h1>{{ $t("scoreNew.title10") }}:</h1>
                  <span><a class="btn_show_details_exam" @click="showDetailsExam(item1)" >{{$t('courseProgress.look')}}</a></span>
                </div>
              </div>
            </div>
          </div>
          <!-- --- moblie ---- -->
        </div>
        <!-- trường hợp không có data thành tích -->
        <div v-if="dataScoreStatic.length==0">
          <div class="nameTestExam">
            <span class="">{{ $t("scoreStaticNew.noInformation") }}</span>
          </div>
        </div>
        <ul>
            <h2 style="margin-bottom: 10px;">{{$t('manage_lesson.lesson_list')}}</h2>
        <li class="div-week-nd" v-for="(item1, index1) in dataResponse" :key="index1">
          <template v-if="index1 == 0">
            <div class="noteDot">
              <span class="dot dot--undone"></span>
              <span>{{$t('week.undone')}}</span>
              <span style="background: #da251d;" class="dot dot--studing"></span>
              <span>{{$t('week.studing')}}</span>
              <span class="dot dot--done"></span>
              <span>{{$t('week.done')}}</span>
            </div>
            <ul class="tb-week font-blod">
              <li>{{$t('week.status')}}</li>
              <li>{{$t('week.exercise')}}</li>
              <li>{{$t('week.score')}}</li>
            </ul>
          </template>
          <template>
            <template v-if="item1.thirdOutlineList == null">
              <ul class="nested parent-ul active">
                <li :class="[{noTitle:item1.thirdOutlineList == null}, {exerciseDoneDraft:item1.learningState == $CONST.MENU.LEARNING_COMPLETED && item1.thirdOutlineList == null}]">
                  <span :class="[{caret:item1.thirdOutlineList != null}, {'caret-down': activeMenu == item1.id || activeMenu == null}]" @click="item1.thirdOutlineList == null ? null : toggleClass($event, item1.id)">{{item1.chapterName}}</span>
                  <ul v-if="item1.thirdOutlineList == null" class="tb-week" :class="[{infoParent:item1.thirdOutlineList == null}]">
                    <!-- status -->
                    <template v-if="item1.thirdOutlineList == null">
                      <template v-if="item1.learningState == $CONST.MENU.LEARNING_COMPLETED">
                        <li><img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/></li>
                      </template>
                      <template v-else-if="item1.learningState == $CONST.MENU.LEARNING">
                        <li><img class="img-bh" src="../../../static/images/baihoc-do.png"/></li>
                      </template>
                      <template v-else>
                        <li><img class="img-bh" src="../../../static/images/baihoc-den.png"/></li>
                      </template>
                    </template>
                    <!-- isExercise -->
                    <template>
                      <template v-if="item1.isExercise != $CONST.MENU.EXERCISE_NONE">
                        <template v-if="item1.questionStatus == $CONST.MENU.EXERCISE_SENT || (parseInt(item1.score) < parseInt(item1.passingRateQuiz))"><li><img src="../../../static/images/baitap-do.png"></li></template>
                        <template v-else-if="item1.questionStatus == $CONST.MENU.EXERCISE_FINISHED"><li><img src="../../../static/images/baitap-xanhla.png"></li></template>
                        <template v-else><li><img src="../../../static/images/baitap-den.png"></li></template>
                      </template>
                      <template v-else><li>—</li></template>
                    </template>
                    <!-- score -->
                    <template>
                      <template v-if="item1.score != '—'">
                        <template v-if="item1.isExercise != $CONST.MENU.EXERCISE_NONE">
                          <li class="nqt-score" :class="[{done_score: item1.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, {}, {}, {}, {}, item1)">
                            <a class="btn-number">{{item1.score}}%</a>
                          </li>
                        </template>
                        <template v-else><li>—</li></template>
                      </template>
                      <template v-else><li>{{item1.score}}</li></template>
                    </template>
                  </ul>
                </li>
              </ul>
            </template>
            <template v-else>
              <span :class="[{caret:item1.thirdOutlineList != null}, {'caret-down': activeMenu == item1.id || activeMenu == null}]" class="parent-ul-ol caret-float" @click="item1.thirdOutlineList == null ? null : toggleClass($event, item1.id)">{{item1.chapterName}}</span>
              <ul v-if="item1.thirdOutlineList == null" class="tb-week" :class="[{infoParent:item1.thirdOutlineList == null}]">
                <!-- status -->
                <template v-if="item1.thirdOutlineList == null">
                  <template v-if="item1.learningState == $CONST.MENU.LEARNING_COMPLETED">
                    <li><img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/></li>
                  </template>
                  <template v-else-if="item1.learningState == $CONST.MENU.LEARNING">
                    <li><img class="img-bh" src="../../../static/images/baihoc-do.png"/></li>
                  </template>
                  <template v-else>
                    <li><img class="img-bh" src="../../../static/images/baihoc-den.png"/></li>
                  </template>
                </template>
                <!-- isExercise -->
                <template>
                  <template v-if="item1.isExercise != $CONST.MENU.EXERCISE_NONE">
                    <template v-if="item1.questionStatus == $CONST.MENU.EXERCISE_SENT || (parseInt(item1.score) < parseInt(item1.passingRateQuiz))"><li><img src="../../../static/images/baitap-do.png"></li></template>
                    <template v-else-if="item1.questionStatus == $CONST.MENU.EXERCISE_FINISHED"><li><img src="../../../static/images/baitap-xanhla.png"></li></template>
                    <template v-else><li><img src="../../../static/images/baitap-den.png"></li></template>
                  </template>
                  <template v-else><li>—</li></template>
                </template>
                <!-- score -->
                <template>
                  <template v-if="item1.score != '—'">
                    <template v-if="item1.isExercise != $CONST.MENU.EXERCISE_NONE">
                      <li class="nqt-score" :class="[{done_score: item1.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, {}, {}, {}, {}, item1)">
                        <a class="btn-number">{{item1.score}}%</a>
                      </li>
                    </template>
                    <template v-else><li>—</li></template>
                  </template>
                  <template v-else><li>{{item1.score}}</li></template>
                </template>
              </ul>
            </template>
          </template>
          <ul v-if="item1.thirdOutlineList != null && item1.thirdOutlineList.length > 0" :class="[{nested:item1.thirdOutlineList != null}, {active:activeMenu == item1.id || activeMenu == null}]">
            <li v-for="(item2, index2) in item1.thirdOutlineList" :class="[{noTitle:item2.thirdOutlineList == null}, {exerciseDoneDraft:item2.learningState == $CONST.MENU.LEARNING_COMPLETED && item2.thirdOutlineList == null}]" :key="index2">
              <span :class="[{caret:item2.thirdOutlineList != null}]" class="caret-down color-2" @click="item2.thirdOutlineList == null ? null : toggleClass($event, item1.id)">{{item2.chapterName}}</span>
              <ul v-if="item2.thirdOutlineList == null" class="tb-week">
                <!-- status -->
                <template v-if="item2.thirdOutlineList == null">
                  <template v-if="item2.learningState == $CONST.MENU.LEARNING_COMPLETED">
                    <li><img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/></li>
                  </template>
                  <template v-else-if="item2.learningState == $CONST.MENU.LEARNING">
                    <li><img class="img-bh" src="../../../static/images/baihoc-do.png"/></li>
                  </template>
                  <template v-else>
                    <li><img class="img-bh" src="../../../static/images/baihoc-den.png"/></li>
                  </template>
                </template>
                <!-- isExercise -->
                <template>
                  <template v-if="item2.isExercise != $CONST.MENU.EXERCISE_NONE">
                    <template v-if="item2.questionStatus == $CONST.MENU.EXERCISE_SENT || (parseInt(item2.score) < parseInt(item2.passingRateQuiz))"><li><img src="../../../static/images/baitap-do.png"></li></template>
                    <template v-else-if="item2.questionStatus == $CONST.MENU.EXERCISE_FINISHED"><li><img src="../../../static/images/baitap-xanhla.png"></li></template>
                    <template v-else><li><img src="../../../static/images/baitap-den.png"></li></template>
                  </template>
                  <template v-else><li>—</li></template>
                </template>
                <!-- score -->
                <template>
                  <template v-if="item2.score != '—'">
                    <template v-if="item2.isExercise != $CONST.MENU.EXERCISE_NONE">
                      <li class="nqt-score" :class="[{done_score: item2.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, item2, {}, {}, {}, item2)">
                        <a class="btn-number">{{item2.score}}%</a>
                      </li>
                    </template>
                    <template v-else><li>—</li></template>
                  </template>
                  <template v-else><li>{{item2.score}}</li></template>
                </template>
              </ul>
              <ul v-if="item2.thirdOutlineList != null && item2.thirdOutlineList.length > 0" :class="[{nested:item2.thirdOutlineList != null}]" class="active">
                <li v-for="(item3, index3) in item2.thirdOutlineList" :class="[{noTitle:item3.thirdOutlineList == null}, {exerciseDoneDraft:item3.learningState == $CONST.MENU.LEARNING_COMPLETED && item3.thirdOutlineList == null}]" :key="index3">
                  <span :class="[{caret:item3.thirdOutlineList != null}]" class="caret-down color-3" @click="item3.thirdOutlineList == null ? null : toggleClass($event, item1.id)">{{item3.chapterName}}</span>
                  <ul v-if="item3.thirdOutlineList == null" class="tb-week">
                    <!-- status -->
                    <template v-if="item3.thirdOutlineList == null">
                      <template v-if="item3.learningState == $CONST.MENU.LEARNING_COMPLETED">
                        <li><img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/></li>
                      </template>
                      <template v-else-if="item3.learningState == $CONST.MENU.LEARNING">
                        <li><img class="img-bh" src="../../../static/images/baihoc-do.png"/></li>
                      </template>
                      <template v-else>
                        <li><img class="img-bh" src="../../../static/images/baihoc-den.png"/></li>
                      </template>
                    </template>
                    <!-- isExercise -->
                    <template>
                      <template v-if="item3.isExercise != $CONST.MENU.EXERCISE_NONE">
                        <template v-if="item3.questionStatus == $CONST.MENU.EXERCISE_SENT || (parseInt(item3.score) < parseInt(item3.passingRateQuiz))"><li><img src="../../../static/images/baitap-do.png"></li></template>
                        <template v-else-if="item3.questionStatus == $CONST.MENU.EXERCISE_FINISHED"><li><img src="../../../static/images/baitap-xanhla.png"></li></template>
                        <template v-else><li><img src="../../../static/images/baitap-den.png"></li></template>
                      </template>
                      <template v-else><li>—</li></template>
                    </template>
                    <!-- score -->
                    <template>
                      <template v-if="item3.score != '—'">
                        <template v-if="item3.isExercise != $CONST.MENU.EXERCISE_NONE">
                          <li class="nqt-score" :class="[{done_score: item3.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, item2, item3, {}, {}, item3)">
                            <a class="btn-number">{{item3.score}}%</a>
                          </li>
                        </template>
                        <template v-else><li>—</li></template>
                      </template>
                      <template v-else><li>{{item3.score}}</li></template>
                    </template>
                  </ul>
                  <ul v-if="item3.thirdOutlineList != null && item3.thirdOutlineList.length > 0" :class="[{nested:item3.thirdOutlineList != null}]" class="active">
                    <li v-for="(item4, index4) in item3.thirdOutlineList" :class="[{noTitle:item4.thirdOutlineList == null}, {exerciseDoneDraft:item4.learningState == $CONST.MENU.LEARNING_COMPLETED && item4.thirdOutlineList == null}]" :key="index4">
                      <span :class="[{caret:item4.thirdOutlineList != null}]" class="caret-down color-4" @click="item4.thirdOutlineList == null ? null : toggleClass($event, item1.id)">{{item4.chapterName}}</span>
                      <ul v-if="item4.thirdOutlineList == null" class="tb-week">
                        <!-- status -->
                        <template v-if="item4.thirdOutlineList == null">
                          <template v-if="item4.learningState == $CONST.MENU.LEARNING_COMPLETED">
                            <li><img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/></li>
                          </template>
                          <template v-else-if="item4.learningState == $CONST.MENU.LEARNING">
                            <li><img class="img-bh" src="../../../static/images/baihoc-do.png"/></li>
                          </template>
                          <template v-else>
                            <li><img class="img-bh" src="../../../static/images/baihoc-den.png"/></li>
                          </template>
                        </template>
                        <!-- isExercise -->
                        <template>
                          <template v-if="item4.isExercise != $CONST.MENU.EXERCISE_NONE">
                            <template v-if="item4.questionStatus == $CONST.MENU.EXERCISE_SENT || (parseInt(item4.score) < parseInt(item4.passingRateQuiz))"><li><img src="../../../static/images/baitap-do.png"></li></template>
                            <template v-else-if="item4.questionStatus == $CONST.MENU.EXERCISE_FINISHED"><li><img src="../../../static/images/baitap-xanhla.png"></li></template>
                            <template v-else><li><img src="../../../static/images/baitap-den.png"></li></template>
                          </template>
                          <template v-else><li>—</li></template>
                        </template>
                        <!-- score -->
                        <template>
                          <template v-if="item4.score != '—'">
                            <template v-if="item4.isExercise != $CONST.MENU.EXERCISE_NONE">
                              <li class="nqt-score" :class="[{done_score: item4.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, item2, item3, item4, {}, item4)">
                                <a class="btn-number">{{item4.score}}%</a>
                              </li>
                            </template>
                           <template v-else><li>—</li></template>
                          </template>
                          <template v-else><li>{{item4.score}}</li></template>
                        </template>
                      </ul>
                      <ul v-if="item4.thirdOutlineList != null && item4.thirdOutlineList.length > 0" :class="[{nested:item4.thirdOutlineList != null}]" class="active">
                        <li v-for="(item5, index5) in item4.thirdOutlineList" :class="[{noTitle:item5.thirdOutlineList == null}, {exerciseDoneDraft:item5.learningState == $CONST.MENU.LEARNING_COMPLETED && item5.thirdOutlineList == null}]" :key="index5">
                          <span :class="[{caret:item5.thirdOutlineList != null}]" class="color-5" @click="item5.thirdOutlineList == null ? null : toggleClass($event, item1.id)">{{item5.chapterName}}</span>
                          <ul v-if="item5.thirdOutlineList == null" class="tb-week">
                            <!-- status -->
                            <template v-if="item5.thirdOutlineList == null">
                              <template v-if="item5.learningState == $CONST.MENU.LEARNING_COMPLETED">
                                <li><img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/></li>
                              </template>
                              <template v-else-if="item5.learningState == $CONST.MENU.LEARNING">
                                <li><img class="img-bh" src="../../../static/images/baihoc-do.png"/></li>
                              </template>
                              <template v-else>
                                <li><img class="img-bh" src="../../../static/images/baihoc-den.png"/></li>
                              </template>
                            </template>
                            <!-- isExercise -->
                            <template>
                              <template v-if="item5.isExercise != $CONST.MENU.EXERCISE_NONE">
                                <template v-if="item5.questionStatus == $CONST.MENU.EXERCISE_SENT || (parseInt(item5.score) < parseInt(item5.passingRateQuiz))"><li><img src="../../../static/images/baitap-do.png"></li></template>
                                <template v-else-if="item5.questionStatus == $CONST.MENU.EXERCISE_FINISHED"><li><img src="../../../static/images/baitap-xanhla.png"></li></template>
                                <template v-else><li><img src="../../../static/images/baitap-den.png"></li></template>
                              </template>
                              <template v-else><li>—</li></template>
                            </template>
                            <!-- score -->
                            <template>
                              <template v-if="item5.score != '—'">
                                <template v-if="item5.isExercise != $CONST.MENU.EXERCISE_NONE">
                                  <li class="nqt-score" :class="[{done_score: item5.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, item2, item3, item4, item5, item5)">
                                    <a class="btn-number">{{item5.score}}%</a>
                                  </li>
                                </template>
                                <template v-else><li>—</li></template>
                              </template>
                              <template v-else><li>{{item5.score}}</li></template>
                            </template>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      </template>
      <template v-else-if="checkTypeStatical==2">
        <wrongAnswerLesson v-on:clickWrongAnswerLesson="clickWrongAnswerLesson($event)" :data="obWrongAnswer" />
      </template>
      <template v-else>
        <wrongExam v-on:clickWrongAnswerLesson="clickWrongAnswerLesson($event)" :data="obWrongExam" />
      </template>
      <!-- The Modal -->
      <div v-if="showDialog" id="myModal" class="modal" :class="{modal_MB:mobile}">
          <!-- Modal content -->
          <div class="modal-content">
            <div class="modal_header">
              <span class="modal_header_name_exam">
                <template v-if="dataDetailsClick.examName=='-'">
                  {{ $t("scoreStatistics.finalExam") }}
                </template>
                <template v-else>
                  {{dataDetailsClick.examName}}
                </template>
              </span>
              <span class="closeModal" v-on:click="closeModal()">
                <div class="img_exit_login">
                  <img src="../../../static/images/wrong-while_hover.png" />
                </div>
              </span>
            </div>
            <div class="modal_body">
              <!-- Hiển thị PC -->
              <div class="modal_body_exam_pc">
                <div class="modal_body_exam">
                  <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("new.title24") }}: </span>{{dataDetailsClick.fullMarks}} {{ $t("scoreStatistics.message2") }}</span>
                  <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.passPercent") }}: </span>{{dataDetailsClick.checkPassMark}} {{ $t("scoreStatistics.message2") }}</span>
                </div>
                <div class="modal_body_exam">
                  <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("examResume.point") }}: </span>{{dataDetailsClick.score}} {{ $t("scoreStatistics.message2") }}</span>
                  <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.result") }}: </span>
                    <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) >= Number(dataDetailsClick.checkPassMark)">{{ $t("scoreStatistics.point90") }}</template>
                    <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) < Number(dataDetailsClick.checkPassMark)">{{ $t("scoreStatistics.point80") }}</template>
                  </span>
                </div>
                <div class="modal_body_exam">
                  <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("examResume.time") }}: </span>{{dataDetailsClick.examDate}}</span>
                  <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("scoreStaticNew.timeExamConductedNew") }}: </span>{{dataDetailsClick.timeExamConduct}} {{ $t("manage_student.minute") }}</span>
                </div>
              </div>
              <!-- Hiển thị MB -->
              <div class="modal_body_exam_mb">
                <div class="modal_body_exam">
                  <span class="modal_body_exam_title">
                    <span class="modal_body_exam_title_tl">{{ $t("new.title24") }}: </span> 
                    <span class="modal_body_exam_title_ct">{{dataDetailsClick.fullMarks}} {{ $t("scoreStatistics.message2") }}</span>
                  </span>
                </div>
                <div class="modal_body_exam">
                  <span class="modal_body_exam_title">
                    <span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.passPercent") }}: </span>
                    <span class="modal_body_exam_title_ct">{{dataDetailsClick.checkPassMark}} {{ $t("scoreStatistics.message2") }}</span>
                  </span>
                </div>
                <div class="modal_body_exam">
                  <span class="modal_body_exam_title">
                    <span class="modal_body_exam_title_tl">{{ $t("examResume.point") }}: </span>
                    <span class="modal_body_exam_title_ct">{{dataDetailsClick.score}} {{ $t("scoreStatistics.message2") }}</span>
                  </span>
                </div>
                <div class="modal_body_exam">
                  <span class="modal_body_exam_title">
                    <span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.result") }}: </span>
                    <span class="modal_body_exam_title_ct">
                      <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) >= Number(dataDetailsClick.checkPassMark)">{{ $t("scoreStatistics.point90") }}</template>
                      <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) < Number(dataDetailsClick.checkPassMark)">{{ $t("scoreStatistics.point80") }}</template>
                    </span>
                  </span>
                </div>
                <div class="modal_body_exam">
                  <span class="modal_body_exam_title">
                    <span class="modal_body_exam_title_tl">{{ $t("examResume.time") }}: </span>
                    <span class="modal_body_exam_title_ct">{{dataDetailsClick.examDate}}</span>
                  </span>
                </div>
                <div class="modal_body_exam">
                  <span class="modal_body_exam_title">
                    <span class="modal_body_exam_title_tl">{{ $t("scoreStaticNew.timeExamConductedNew") }}: </span>
                    <span class="modal_body_exam_title_ct">{{dataDetailsClick.timeExamConduct}} {{ $t("manage_student.minute") }}</span>
                  </span>
                </div>
              </div>
              <!-- Menu mục lục -->
              <div class="modal_body_currilumn">
                <span class="modal_body_currilumn_header">{{ $t("scoreNew.title1") }}</span>
                <chartDetailExam
                    :data="{
                        recordId  : this.recordId,
                        studentId : this.data.studentId,
                        courseId  : this.data.courseId,
                        examId    : this.examId
                    }"
                />
              </div>
            </div>
          </div>
      </div>
      <loading class="loading--lesson" :showLoading="!isLoadData" />
    </div>
</template>

<script>
import loading from "@/components/loading/loading";
import wrongAnswerLesson from "@/components/manage/wrongAnswerLesson";
import wrongExam from "@/components/manage/listWrongExam";
import chartDetailExam from "@/components/exam/chartDetailExam";
export default {
    data() {
        return {
            activeID: null,
            isLoadData: false,
            dataResponse: [],
            activeMenu: null,
            courseName: "",
            dataScoreStatic: [],
            chartDataLesson: {
                columns: [this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME, this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT],
                series: [],
                chartSettings: {},
                rows: [
                    {[this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME]: "Học xong", [this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT]: this.$CONST.COMMON.NUMBER.ZERO},
                    {[this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME]: "Chưa học", [this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT]: this.$CONST.COMMON.NUMBER.ZERO},
                    {[this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME]: "Đang học", [this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT]: this.$CONST.COMMON.NUMBER.ZERO},
                ]
            },
            chartDataExercise: {
                columns: [this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME, this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT],
                rows: [
                    {[this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME]: "Đã chấm bài", [this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT]: this.$CONST.COMMON.NUMBER.ZERO},
                    {[this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME]: "Chưa làm bài", [this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT]: this.$CONST.COMMON.NUMBER.ZERO},
                    {[this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME]: "Đang gởi chấm bài", [this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT]: this.$CONST.COMMON.NUMBER.ZERO}
                ]
            },
            totalStatusLesson: this.$CONST.COMMON.NUMBER.ZERO,
            totalStatusExercise: this.$CONST.COMMON.NUMBER.ZERO,
            chartData4: {
                rows: [
                    {[this.$CONST.MANAGE.STATICTICAL.LINE.GRADES]: "Điểm hiện tại", [this.$CONST.MANAGE.STATICTICAL.LINE.SCORE]: this.$CONST.COMMON.STRING.IS_BLANK},
                    {[this.$CONST.MANAGE.STATICTICAL.LINE.GRADES]: "Điểm trung bình", [this.$CONST.MANAGE.STATICTICAL.LINE.SCORE]: this.$CONST.COMMON.STRING.IS_BLANK},
                    {[this.$CONST.MANAGE.STATICTICAL.LINE.GRADES]: "Điểm cao nhất", [this.$CONST.MANAGE.STATICTICAL.LINE.SCORE]: this.$CONST.COMMON.STRING.IS_BLANK},
                    {[this.$CONST.MANAGE.STATICTICAL.LINE.GRADES]: "Điểm thấp nhất", [this.$CONST.MANAGE.STATICTICAL.LINE.SCORE]: this.$CONST.COMMON.STRING.IS_BLANK}
                ],
            },
            chartSettings: {
                metrics: [this.$CONST.MANAGE.STATICTICAL.LINE.SCORE], 
                dimension: [this.$CONST.MANAGE.STATICTICAL.LINE.GRADES]
            },
            colors: this.$CONST.MANAGE.STATICTICAL.LINE.SERIES.STYLE.COLORLIST,
            series: [
                {
                    name: this.$CONST.MANAGE.STATICTICAL.LINE.SERIES.NAME,
                    type: this.$CONST.MANAGE.STATICTICAL.LINE.SERIES.TYPE,
                    barWidth: this.$CONST.MANAGE.STATICTICAL.LINE.SERIES.WIDTH,
                    data: [],
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colors = ["#65d186", "#f67287", "#f29e3c", "#c05bdd"];
                                return colors[params.dataIndex];
                            },
                        }
                    }
                }
            ],
            xValueList: [],
            courseProgress: 0,
            checkTypeStatical:1,
            obWrongAnswer: {},
            showDialog: false,
            dataDetailsClick: null,
            listDataDetailsShowDialog: [],
            obWrongExam: {},
            recordId: null,
            examId: null
        };
    },
    components: {
      loading,
      wrongAnswerLesson,
      wrongExam,
      chartDetailExam
    },
    props: {
        data: {
            type: Object,
            default: {}
        }
    },
    computed: {
      mobile() {
        return this.$store.getters["header/mobile"];
      },
    },
    created () {
        document.getElementsByTagName('body')[0].scrollTop = 0;
        /// name lesson
        this.chartDataLesson.rows[this.$CONST.COMMON.NUMBER.ZERO][this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME] = window.vm.$i18n.t("statictical.completed");
        this.chartDataLesson.rows[this.$CONST.COMMON.NUMBER.ONE][this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME] = window.vm.$i18n.t("statictical.unstudied");
        this.chartDataLesson.rows[this.$CONST.COMMON.NUMBER.TWO][this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME] = window.vm.$i18n.t("statictical.studying");
        /// name excersive
        this.chartDataExercise.rows[this.$CONST.COMMON.NUMBER.ZERO][this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME] = window.vm.$i18n.t("statictical.scored");
        this.chartDataExercise.rows[this.$CONST.COMMON.NUMBER.ONE][this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME] = window.vm.$i18n.t("statictical.unscored");
        this.chartDataExercise.rows[this.$CONST.COMMON.NUMBER.TWO][this.$CONST.MANAGE.STATICTICAL.COLUMNS.NAME] = window.vm.$i18n.t("statictical.waiting_scoring");
        this.init();
    },
    async mounted(){
      this.infoCourseScoreStatic();
    },
    methods: {
        clickWrongAnswerLesson(params){
          this.checkTypeStatical = params;
          this.$emit("clickTypeNonLesson", 1);
        },
        activeRow: function (activeID) {
          if (this.activeID == activeID && this.activeID != null) {
            this.activeID =  null;
          } else {
            this.activeID = activeID;
          }
        },
        infoCourseScoreStatic: async function () {
          this.isLoadData = false;
          const self = this;
          var scoreStatic = await this.getDataScoreStatic();
          var listScoreStatic = [];
          scoreStatic.forEach(value => {
            if (value.examId!=null&&value.examName==null) {
              return;
            } else {
              listScoreStatic.push(value);
            }
          });
          Promise.all(listScoreStatic.map(item => {
              return self.getHistoryDataScoreStatic(item);
          })).then(function(results) {
            self.dataScoreStatic = results;
            self.isLoadData = true;
          })
        },
        getDataScoreStatic: function () {
          return new Promise((resolve, reject) => {
            this.$api
            .post("/home/getsingleCourseScoreStatistics", {
                userId: this.data.studentId,
                courseId: this.data.courseId,
                languageType: this.$lang()
            })
            .then((response) => {
              resolve(response.data);
            })
            .catch((err) => {
                reject(err.response);
            });
          });
        },
        getHistoryDataScoreStatic: function (item) {
          return new Promise((resolve, reject) => {
            let courseIdHistoryDataScoreStatic = null;
            let examIdHistoryDataScoreStatic = null;
            if (item.examId) {
              examIdHistoryDataScoreStatic = item.examId;
            } else {
              courseIdHistoryDataScoreStatic = this.data.courseId;
            }
            this.$api
            .post("/home/getExamRecord", {
                userId: this.data.studentId,
                courseId: courseIdHistoryDataScoreStatic,
                examId: examIdHistoryDataScoreStatic,
                languageType: this.$lang()
            })
            .then((response) => {
              item["fullMarksScore"] = null;
              item["passPercentScore"] = null;
              item["listHistoryScoreStatic"] = response.data.list;
              response.data.list.forEach(element => {
                item.fullMarksScore = parseInt(element.fullMarks);
                element["examId"] = examIdHistoryDataScoreStatic;
                element["checkPassMark"] = (parseInt(element.fullMarks) / 100) * item.passPercent;
                item.passPercentScore = (parseInt(element.fullMarks) / 100) * item.passPercent;
              });
              item["historyScoreStatic"] = response.data;
              resolve(item);
            })
            .catch((err) => {
                reject(err.response);
            });
          });
        },
        init: function () {
            this.courseName = this.data.nameCourse;
            if(this.data.studentId){
                this.loadData();
                this.getcourseProgress();
            }
        },
        getcourseProgress(){
            this.$api.post("/courseStudy/getCourseProcess", {
                courseId: this.data.courseId,
                studentId: this.data.studentId 
            }).then((response) => {
                this.courseProgress = response.data;
            }).catch((err) => {
                // console.log(err.response);
            });
        },
        loadData: function () {
            this.$api.post("/courseStudy/getCourseSubOutlineListByTopOutline", {
                courseId: this.data.courseId,
                userId: this.data.studentId
            }).then((response) => {
                let dataCp = response.data;
                dataCp.forEach(async (item, i) => {
                  let keyParent = dataCp.findIndex(x => x.id == item.parentId);
                  if (keyParent >= 0) {
                    dataCp[keyParent].thirdOutlineList = dataCp[keyParent].thirdOutlineList == null ? [] : dataCp[keyParent].thirdOutlineList;
                    dataCp[keyParent].thirdOutlineList.push(item);
                  }
                });
                this.dataResponse = dataCp.filter((x) => {return x.level == 1});
                // ======= trang thai hoc bai ================
                let arrHavenotLearn = [];
                let arrlearning = [];
                let arrHaveLearn = [];
                // ====== trang thai lam bai tap 
                let arrHaveNotExercise = [];
                let arrSendingExercise = [];
                let arrCompleteExercise = [];
                dataCp.forEach((item, i) => {
                    // ======= trang thai hoc bai ================
                    if(item.isBuy==1){
                        if(item.learningState==0){
                            // Học xong
                            arrHaveLearn.push(item);
                        } else if(item.learningState==2){
                            /// Đang học
                            arrlearning.push(item);
                        } else {
                            /// Chưa học
                            arrHavenotLearn.push(item);
                        }
                    }
                    // ======= trang thai hoc bai ================
                    // ====== trang thai lam bai tap 
                    if(item.isExercise != 0){
                        if(item.questionStatus==2){
                            // goi di
                            arrSendingExercise.push(item);
                        } else if(item.questionStatus==1){
                            // hoan thanh
                            arrCompleteExercise.push(item);
                        } else {
                            // chua lam
                            arrHaveNotExercise.push(item);
                        }
                    }
                    // ====== trang thai lam bai tap 
                });
                // ====== total 
                this.totalStatusLesson = arrHaveLearn.length + arrHavenotLearn.length + arrlearning.length;
                this.totalStatusExercise = arrCompleteExercise.length + arrHaveNotExercise.length + arrSendingExercise.length;
                // ====== trang thai lam bai tap 
                // // Đặt giá trị cho DataLesson
                this.chartDataLesson.rows[this.$CONST.COMMON.NUMBER.ZERO][this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT] = arrHaveLearn.length;
                this.chartDataLesson.rows[this.$CONST.COMMON.NUMBER.ONE][this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT] = arrHavenotLearn.length;
                this.chartDataLesson.rows[this.$CONST.COMMON.NUMBER.TWO][this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT] = arrlearning.length;
                // // Đặt giá trị cho DataExercise
                this.chartDataExercise.rows[this.$CONST.COMMON.NUMBER.ZERO][this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT] = arrCompleteExercise.length;
                this.chartDataExercise.rows[this.$CONST.COMMON.NUMBER.ONE][this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT] = arrHaveNotExercise.length;
                this.chartDataExercise.rows[this.$CONST.COMMON.NUMBER.TWO][this.$CONST.MANAGE.STATICTICAL.COLUMNS.PERCENT] = arrSendingExercise.length;
                // // Đặt giá trị cho biểu đồ ChartLine
                this.xValueList[this.$CONST.COMMON.NUMBER.ZERO] = 1;
                this.xValueList[this.$CONST.COMMON.NUMBER.ONE] = 2;
                this.xValueList[this.$CONST.COMMON.NUMBER.TWO] = 0.3;
                this.xValueList[this.$CONST.COMMON.NUMBER.THREE] = 0.5;
                this.series[this.$CONST.COMMON.NUMBER.ZERO].data = this.xValueList;
            }).catch((err) => {
                // console.log(err.response);
            });
        },
        jumpTaskResult: function (item1, item2, item3, item4, item5, oop) {
            if (oop.thirdOutlineList != null) return;
            this.checkTypeStatical = 2;
            this.$emit("clickTypeNonLesson", 2);
            this.obWrongAnswer = {
              courseName: this.data.nameCourse,
              studentId: this.data.studentId,
              courseOutlineId: oop.id
            };
            // let outlineInfo = {
            //     "topId": item1.id != undefined ? item1.id : null,
            //     "secondId": item2.id != undefined ? item2.id : null,
            //     "secondChapterName": oop.chapterName,
            //     "thirdId": item3.id != undefined ? item3.id : null,
            //     "fourthId": item4.id != undefined ? item4.id : null,
            //     "fifthId": item5.id != undefined ? item5.id : null,
            //     "type": this.$CONST.MENU.TYPE,
            //     "courseId": oop.courseId,
            //     "courseName": this.courseName,
            //     "courseOutlineId":oop.id
            // };
            // this.$router.push({
            //     path: "students/task/result",
            //     query: {
            //         outlineInfo: JSON.stringify(outlineInfo),
            //         studentId: this.data.studentId,
            //         pageManage: "lesson"
            //     }
            // });
        },
        /// Hiển thị dialog chi tiết thi
        showDetailsExam(params) {
          this.isLoadData       = false;
          this.dataDetailsClick = params;
          this.recordId         = params.id;
          this.examId           = params.examId || null;
          this.isLoadData       = true;
          this.showDialog       = true;
        },
        /// Đóng dialog
        closeModal(){
          this.showDialog = false;
        },
        /// DownLoad file của từng phần thi
        downLoadFile(params){
          let tempList = [];
          let dataClick = params;
          this.isLoadData = false;
          let courseIdHistoryDataScoreStatic = this.data.courseId;
          let examIdHistoryDataScoreStatic = null;
          if (params.examId) {
            examIdHistoryDataScoreStatic = params.examId;
          }
          let temp = [];
          this.$api
            .post("/courseStudy/getScoreRate", {
              id: params.id,
              studentId: this.data.studentId,
              courseId: courseIdHistoryDataScoreStatic,
              examId: examIdHistoryDataScoreStatic
            }).then((response) => {
              this.isLoadData = true;
              response.data.forEach(value => {
                value["timeBegin"] = dataClick.timeExamStart;
                value["timeEnd"] = dataClick.timeExamEnd;
                if (value.totalAnswer!=null) {
                  value["wrongAnswer"] = parseInt(value.totalAnswer) - parseInt(value.rightAnswer);
                } else {
                  value["wrongAnswer"] = "-";
                  value.totalAnswer = "-";
                  value.rightAnswer = "-";
                  value.score = "-";
                }
                temp.push(value);
              }); 
              
              temp.forEach(el => {
                if (el.score !== "-") {
                  tempList.push(el);
                }
              });

              var headerName = [
                  {
                      key: "timeBegin",
                      value: "scoreStaticNew.timeExamStart"
                  },
                  {
                      key: "timeEnd",
                      value: "scoreStaticNew.timeExamEnd"
                  },
                  {
                      key: "chapterName",
                      value: "scoreNew.title4"
                  },
                  {
                      key: "totalAnswer",
                      value: "scoreNew.title5"
                  },
                  {
                      key: "rightAnswer",
                      value: "scoreNew.title6"
                  },
                  {
                      key: "wrongAnswer",
                      value: "scoreNew.title7"
                  },
                  {
                      key: "score",
                      value: "scoreNew.title8"
                  }
              ]
              var params = {
                  header: true,
                  titles: ["timeBegin", "timeEnd", "chapterName", "totalAnswer", "rightAnswer", "wrongAnswer", "score"],
                  data: tempList,
                  headerName: headerName,
                  name: "exportDetailExam.csv"
              }
              this.exportCsv(params);
            })
        },
        /// Down load tất cả thành tích thi của bài thi đó
        downLoadAll(params){
          const self = this;
          if (params.listHistoryScoreStatic) {
            this.isLoadData = false;
            Promise.all(params.listHistoryScoreStatic.map(item => {
                return self.getDataScoreExam(params, item);
            })).then(function(results) {
              let tempList = [];
              let temp = [];
              results.forEach(item => {
                item.listDataScore.forEach(value => {
                  temp.push(value);
                });
              });
              temp.forEach(el => {
                if (el.score !== "-") {
                  tempList.push(el);
                }
              });
              self.isLoadData = true;
              var headerName = [
                  {
                      key: "timeBegin",
                      value: "scoreStaticNew.timeExamStart"
                  },
                  {
                      key: "timeEnd",
                      value: "scoreStaticNew.timeExamEnd"
                  },
                  {
                      key: "chapterName",
                      value: "scoreNew.title4"
                  },
                  {
                      key: "totalAnswer",
                      value: "scoreNew.title5"
                  },
                  {
                      key: "rightAnswer",
                      value: "scoreNew.title6"
                  },
                  {
                      key: "wrongAnswer",
                      value: "scoreNew.title7"
                  },
                  {
                      key: "score",
                      value: "scoreNew.title8"
                  }
              ]
              var paramsrs = {
                  header: true,
                  titles: ["timeBegin", "timeEnd", "chapterName", "totalAnswer", "rightAnswer", "wrongAnswer", "score"],
                  data: tempList,
                  headerName: headerName,
                  name: "exportDetailExam.csv"
              }
              self.exportCsv(paramsrs);
            });
          }
        },
        /// get thông tin thành tích thi từng mục
        getDataScoreExam(params, item){
          const self = this;
          return new Promise((resolve, reject) => {
            let dataClick = item;
            let courseIdHistoryDataScoreStatic = this.data.courseId;
            let examIdHistoryDataScoreStatic = null;
            if (params.examId) {
              examIdHistoryDataScoreStatic = params.examId;
            }
            this.$api
              .post("/courseStudy/getScoreRate", {
                id: item.id,
                studentId: this.data.studentId,
                courseId: courseIdHistoryDataScoreStatic,
                examId: examIdHistoryDataScoreStatic
              }).then((response) => {
                response.data.forEach(value => {
                  value["timeBegin"] = dataClick.timeExamStart;
                  value["timeEnd"] = dataClick.timeExamEnd;
                  if (value.totalAnswer!=null) {
                    value["wrongAnswer"] = parseInt(value.totalAnswer) - parseInt(value.rightAnswer);
                  } else {
                    value["wrongAnswer"] = "-";
                    value.totalAnswer = "-";
                    value.rightAnswer = "-";
                    value.score = "-";
                  }
                });
                item["listDataScore"] = response.data;
                resolve(item);
              }).catch((err) => {
                  reject(err.response);
              });
          });
        },
        /// Lấy danh sách câu trả lời sai
        getWrongBookUser(params) {
          this.isLoadData = false;
          this.$api
            .post("/studyCourseQuestion/getWrongBook", {
                languageType: this.$lang(),
                courseId: this.data.courseId,
                examId: params.examId,
                userId: this.data.studentId
            })
            .then(response => {
              this.isLoadData = true;
              if (response.data.length==0) {
                this.$confirm(window.vm.$i18n.t("new.title194"),
                    window.vm.$i18n.t("new.title86"),
                    {cancelButtonClass: "btn-nqt---show"}
                ).then(() => {}).catch(() => {});
              } else {
                this.obWrongExam = response.data;
                this.checkTypeStatical = 3;
                this.$emit("clickTypeNonLesson", 3);
              }
            });
        }
    }
};
</script>
<style scoped>
    .tb-week img {
      cursor: auto;
    }
    .flex-tt {
        margin-top: 30px;
    }
    .btn-number {
      margin-left: 1px!important;
    }
    .exam_begins_box{
      margin: 15px auto 0!important;
    }
    .nameTestExam {
      padding-left: 22px;
      font-size: 15px;
    }
    @media (max-width: 480px) {
      .nameTestExam {
        padding-left: 6px;
        font-size: 15px;
      }
    }
    /* Hiển thị modal */
.btn_show_details_exam {
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  padding: 3px 8px;
  border-radius: 15px;
  -webkit-transition: 0.5s ease;
  transition: 0.5s ease;
  color: #fff;
}
.modal {
  position: fixed; /* Stay in place */
  z-index: 1000001; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}
/* Modal Content */
.modal-content {
  background-color: #fefefe;
  /* background-image: linear-gradient(0deg, #d5f1ff 0%, #53e0fd 100%); */
  margin: auto;
  padding: 0px 10px;
  border: 1px solid #888;
  width: 50%;
  border-radius: 10px;
  min-height: 100px;
}
.img_exit_login{
  float: right;
  margin-right: 0px;
  margin-top: 0px;
  padding: 0px;
  cursor: pointer;
}
.modal_header_name_exam {
  font-weight: bold;
  font-size: 18px;
}
.modal_header {
  padding-top: 5px;
}
.modal_body {
  padding-top: 20px;
}
.modal_body_exam {
  display: flex;
}
.modal_body_exam .modal_body_exam_title{
  font-size: 13px;
  width: 50%;
  padding-top: 1vh;
}
.modal_body_exam_title_tl {
  font-weight: bold;
}
.modal_body_currilumn {
  padding-top: 2vh;
  padding-bottom: 2vh;
}
.modal_body_currilumn_header {
  font-size: 14px;
  font-weight: bold;
}
.modal_body_currilumn_header_hd {
  display: flex;
  padding: 1vh 0vh;
  font-size: 13px;
}
.modal_body_currilumn_header_hd span{
  font-weight: bold;
}
.modal_body_currilumn_header_bd {
  padding: 1vh 0vh;
  display: flex;
  font-size: 13px;
}
.tnv_ct {
  width: 60%;
}
.tnv_as {
  width: 20%;
  text-align: center;
}
.tnv_score {
  width: 20%;
  text-align: center;
}
.btn-download-tt {
  height: 40px;
  border: 2px solid #0071c5;
  background-color: #ffffff;
  color: black;
  font-size: 12px;
  font-weight: bold;
  border-radius: 5px;
  margin-top: 5px;
  margin-bottom: 0;
  transition: ease 0.5s;
  /* width: 140px; */
  position: relative;
}
/* MB */
.content_new .btn_show_details_exam {
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  padding: 3px 8px;
  border-radius: 15px;
  -webkit-transition: 0.5s ease;
  transition: 0.5s ease;
  color: #fff;
}
.modal_MB .modal-content {
  width: 90% !important;
}
.modal_body_exam_mb {
  display: none;
}
@media (max-width: 480px) {
  .modal_body_exam_mb {
    display: unset;
  }
  .modal_body_exam_mb .modal_body_exam {
    border-bottom: 1px solid #e2dfdf;
  }
  .modal_body_exam_mb .modal_body_exam_title{
    width: 100%;
  }
  .modal_body_exam_pc {
    display: none;
  }
  .modal_body_exam_title_ct {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/manage/statictical.vue